import {
	Box,
	Center,
	Flex,
	Icon,
	Link,
	Text,
	HStack,
	VStack,
	IconButton,
	useDisclosure,
} from '@chakra-ui/react'
import React, { useState, useRef } from 'react'
import { BsFileEarmark, BsReply } from 'react-icons/bs'
import { FaExternalLinkAlt } from 'react-icons/fa'
import { MdMoreVert, MdReply } from 'react-icons/md'
import CustomMenu from '../../../components/menu'
import {
	GA_CATEGORY_TIMELINE,
	sectionDetailedTrack,
} from '../../../containers/repository/repo.utils'
import { formatHHMM, getUTCtoIST } from '../../../utils/date.utils'
import {
	Menu,
	MenuButton,
	MenuList,
	MenuItem,
	MenuItemOption,
	MenuGroup,
	MenuOptionGroup,
	MenuDivider,
} from '@chakra-ui/react'
import SVGIcon from '../../../assets/svgIcons'

const ArticleUpdate = ({ timeline, asset_id, timelineReplyData }) => {
	const {
		operating_asset_first_name,
		data_entity_inline,
		datetime_log,
		log_asset_id,
		timeline_transaction_id,
	} = timeline
	const {
		isOpen: menuIsOpen,
		onOpen: menuOnOpen,
		onClose: menuOnClose,
	} = useDisclosure()

	const payload = JSON.parse(data_entity_inline)

	let iconColor = log_asset_id === asset_id ? 'white' : '#009B76'
	const [isHover, setIsHover] = useState(false)
	const showMenu = useRef(false)
	let bg = log_asset_id === asset_id ? '#009B76' : 'white'

	const getCustomMenu = () => {
		return (
			<Menu isOpen={menuIsOpen}>
				<MenuButton
					as={IconButton}
					icon={
						<SVGIcon
							iconName='UpArrowSvg'
							svgProps={{ width: '18', height: '18', viewBox: '0 0 18 18' }}
							pathProps={{ fill: iconColor }}
						/>
					}
					bg={log_asset_id === asset_id ? '#009B76' : 'white'}
					_focus={{
						bg: { bg },
					}}
					_hover={{
						bg: { bg },
					}}
					_active={{
						bg: { bg },
					}}
					border='none'
					aria-label='Sort'
					size='xs'
					ml='auto'
					top='0px'
					right='0px'
					pt='8px'
					variant='outline'
					onClick={() => {
						showMenu.current = !showMenu.current
						showMenu.current ? menuOnOpen() : menuOnClose()
					}}
				/>
				<MenuList
					overflowY='auto'
					maxHeight='50vh'
					boxShadow='0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);'
					borderRadius='18px'
				>
					<MenuItem
						size='sm'
						py={1}
						color='#009B76'
						icon={<Icon as={BsReply} w={5} h={5} color='#009B76' />}
						onClick={e => {
							sectionDetailedTrack({
								category: GA_CATEGORY_TIMELINE,
								action: 'Article Update',
								label: 'Timeline Reply',
							})
							timelineReplyData({ ...timeline, title: payload.content })
						}}
					>
						Reply
					</MenuItem>
				</MenuList>
			</Menu>
		)
	}

	const showUpArrow = () => {
		setIsHover(true)
	}

	const hideUpArrow = () => {
		showMenu.current = false
		menuOnClose()
		setIsHover(false)
	}
	return (
		<Flex
			id={`reply_item${timeline_transaction_id}`}
			justifyContent='flex-start'
			alignItems='flex-start'
			my={4}
			flexDirection={log_asset_id === asset_id ? 'row-reverse' : 'row'}
		>
			<VStack
				justifyContent='space-around'
				alignItems='center'
				bg={log_asset_id === asset_id ? 'gray.700' : 'white'}
				borderRadius={
					log_asset_id === asset_id
						? '15px 15px 0px 15px'
						: '0px 12px 12px 12px'
				}
				minh='170px'
				maxh='250px'
				minW='200px'
				maxW='500px'
				mx={2}
				px='1rem'
				py={2}
				mr='2rem'
				position='relative'
				cursor={'pointer'}
				onMouseEnter={() => showUpArrow()}
				onMouseLeave={() => hideUpArrow()}
			>
				{log_asset_id !== asset_id && (
					<HStack justifyContent='space-between' w='100%'>
						<Text color='brand.700' fontSize='0.875rem' fontWeight='500'>
							{operating_asset_first_name}
						</Text>
						<Box visibility={isHover ? 'visible' : 'hidden'}>
							{getCustomMenu()}
						</Box>

						{/* <CustomMenu
							icon={MdMoreVert}
							color='brand.800'
							borderRadius='md'
							boxShadow={0}
							aria-label='More'
							bg={'secondary'}
							size='sm'
							top='0px'
							right='0px'
							optionList={[
								{
									label: `Reply`,
									isMenu: true,
									icon: <Icon as={MdReply} w={5} h={5} color='brand.900' />,
									onClick: e => {
										sectionDetailedTrack({
											category: GA_CATEGORY_TIMELINE,
											action: 'Article Update',
											label: 'Timeline Reply',
										})
										timelineReplyData({ ...timeline, title: payload.content })
									},
								},
							]}
							selected={{}}
						/> */}
					</HStack>
				)}
				<Flex
					justifyContent='center'
					align='center'
					h='90px'
					w='90px'
					bg='white'
					borderRadius='lg'
				>
					<Center position='relative'>
						<Box position='absolute' left='0' px={2} bg='white'>
							<Text fontSize='12px' textTransform='uppercase'>
								pdf
							</Text>
						</Box>
						<Icon as={BsFileEarmark} color='brand.900' h='4rem' w='4rem' />
					</Center>
				</Flex>
				<Text textAlign='center' fontSize='sm'>
					{payload.subject}
					<br />
					<Link color='blue.400' target='_blank' href={payload.content}>
						Click Here <Icon as={FaExternalLinkAlt} mx='2px' />
					</Link>
				</Text>
				<Text fontSize='10px' mb={0} alignSelf='flex-end'>
					{formatHHMM(getUTCtoIST(datetime_log))}
				</Text>
			</VStack>
		</Flex>
	)
}

export default ArticleUpdate
